import '@shared/styles/reset.less'; // TODO: 换用 normalize.css
import '@shared/styles/base.less'; // TODO: 有很多 antd-mobile 中的样式处理，在 vue 中酌情移除或重新实现
import '@shared/styles/wx-article.less';
import '@shared/styles/vant-override.less';
import '@shared/assets/font/iconfont.css';
// import '@shared/styles/common.less'; // TODO: 弃用，迁移相关页面时重新实现
// import '@shared/styles/animate.css'; // TODO: 弃用，迁移相关页面时重新实现
// import '@shared/styles/swiper.min.css'; // TODO: 弃用，迁移相关页面时重新实现

// 引入静态资源
export function setupAssets() {
  // 覆盖vant遮罩的背景色,用静态样式的覆盖写法,因为自定义样式变量加载太早,会被vant覆盖而不生效
  setTimeout(() => {
    document.documentElement.style.setProperty('--van-overlay-background-color', 'rgba(0, 0, 0, .4)');
  }, 0);
}
